import { FilterFunction, Row, ValueSelectorFunction } from "@cadmakers/data-grid-v2";
import { getSelectedValue } from "./GetSelectedValue";
import { RelationshipFilterOptions } from "../../../../Constants/filterEnum";

const getRowValueByColumnId = (
  row: Row,
  columnId: string,
  valueSelector?: ValueSelectorFunction
) => {
  return getSelectedValue(row.values[columnId], valueSelector);
};

const selectAllRows: FilterFunction<string[]> = rows => {
  return rows.map((item, index) => index);
};

const filterByRelationship: FilterFunction<string[]> = (rows, id, filterValue, valueSelector) => {
  if (
    filterValue.includes(RelationshipFilterOptions.All) ||
    (filterValue.includes(RelationshipFilterOptions.Child) &&
      filterValue.includes(RelationshipFilterOptions.Parent) &&
      filterValue.includes(RelationshipFilterOptions.NonGrouped))
  ) {
    return selectAllRows(rows, id, filterValue, valueSelector);
  }

  const indicies: number[] = [];

  if (filterValue.includes(RelationshipFilterOptions.Child)) {
    rows.forEach((row, index) => {
      if (row.values.title.isChild) {
        indicies.push(index);
      }
    });
  }

  if (filterValue.includes(RelationshipFilterOptions.Parent)) {
    rows.forEach((row, index) => {
      if (!indicies.includes(index) && row.values.title.isParent) {
        indicies.push(index);
      }
    });
  }

  if (filterValue.includes(RelationshipFilterOptions.NonGrouped)) {
    rows.forEach((row, index) => {
      if (!indicies.includes(index) && !row.values.title.isGrouped) {
        indicies.push(index);
      }
    });
  }

  return indicies;
};

export const TitleRelationshipFilter: FilterFunction<string[]> = (
  rows,
  id,
  filterValue,
  valueSelector
) => {
  let indicies: number[] = [];
  const terms = filterValue;

  if (
    terms.includes(RelationshipFilterOptions.All) ||
    terms.includes(RelationshipFilterOptions.Parent) ||
    terms.includes(RelationshipFilterOptions.Child) ||
    terms.includes(RelationshipFilterOptions.NonGrouped)
  ) {
    indicies = filterByRelationship(rows, id, terms, valueSelector);
  }

  rows.forEach((row, index) => {
    const value = getRowValueByColumnId(row, id, valueSelector);

    if (!indicies.includes(index) && filterValue.includes(value)) {
      indicies.push(index);
    }
  });
  return indicies;
};
